module.exports = __webpack_public_path__ + "img/icon-exchange.af053509.svg";